import { useEffect, useRef } from "react";
import Hls from "hls.js";

const handlePlayError = (err: Error) => {
  // Only log power-saving related errors in development
  if (err.name !== 'AbortError') {
    console.error("Video playback error:", err);
  }
};

const VideoComponent = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // Set initial video properties
    videoElement.muted = true;
    videoElement.playsInline = true;
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('webkit-playsinline', '');

    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource("https://videodelivery.net/59d82ffef688129aa31645d72656ac7f/manifest/video.m3u8");
      hls.attachMedia(videoElement);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        videoElement.play().catch(handlePlayError);
      });
    } else if (videoElement.canPlayType("application/vnd.apple.mpegurl")) {
      // Some browsers (iOS Safari, etc.) support HLS natively
      videoElement.src = "https://videodelivery.net/59d82ffef688129aa31645d72656ac7f/manifest/video.m3u8";
      videoElement.play().catch(handlePlayError);
    } else {
      // Fallback to MP4 if HLS is not supported
      videoElement.src = "https://videodelivery.net/59d82ffef688129aa31645d72656ac7f/video.mp4";
      videoElement.play().catch(handlePlayError);
    }

    // Cleanup
    return () => {
      videoElement.pause();
      videoElement.src = '';
    };
  }, []);

  return (
    <video
      ref={videoRef}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      className="w-full h-full"
    >
      {/* Fallback message */}
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoComponent;